import { render, staticRenderFns } from "./ClinicianProgramFormWrapper.vue?vue&type=template&id=18a4f65b"
import script from "./ClinicianProgramFormWrapper.vue?vue&type=script&lang=js"
export * from "./ClinicianProgramFormWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports